import { useState, useRef } from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import { FileAddIcon, CheckmarkCircle01Icon, Cancel01Icon } from '@hugeicons/core-free-icons';
import { fileSize } from '../../utils/constants';

function FormUpload({ label, name, id, setValue, required }) {

    const [fileName, setFileName] = useState(null);
    const [size, setSize] = useState(0);
    const inputRef = useRef(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setFileName(file.name);
        setValue(file);
        setSize(file.size);
    };

    const handleRemove = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setFileName(null);
        setSize(0);
        setValue(undefined);
        if (inputRef.current) inputRef.current.value = '';
    };

    return (
        <div>
            <label className="block text-xs font-medium text-gray-500 mb-1.5">{label}</label>
            <label
                htmlFor={id}
                className={`relative flex flex-col items-center justify-center rounded-xl border-2 border-dashed px-4 py-6 cursor-pointer transition-colors ${
                    fileName
                        ? 'border-emerald-200 dark:border-emerald-500/40 bg-emerald-50/40 dark:bg-emerald-500/10 hover:bg-emerald-50/60 dark:hover:bg-emerald-500/15'
                        : 'border-gray-200 dark:border-gray-600 bg-gray-50/40 dark:bg-gray-700/30 hover:bg-gray-50/60 dark:hover:bg-gray-700/50 hover:border-[#1e3a6e]/30 dark:hover:border-blue-500/40'
                }`}
            >
                <input
                    ref={inputRef}
                    id={id}
                    name={name}
                    type="file"
                    className="sr-only"
                    onChange={handleFileChange}
                    accept="image/*, .doc, .docx, .pdf, .xls, .xlsx"
                    required={required && !fileName}
                />

                {fileName ? (
                    <>
                        <HugeiconsIcon icon={CheckmarkCircle01Icon} size={22} className="text-emerald-500 mb-2" />
                        <p className="text-xs font-medium text-emerald-700 dark:text-emerald-400 truncate max-w-full text-center px-4">{fileName}</p>
                        <p className="text-[10px] text-emerald-500 mt-0.5">{fileSize(size)}</p>

                        <button
                            type="button"
                            onClick={handleRemove}
                            className="absolute top-2 right-2 p-1 rounded-full bg-white dark:bg-gray-800 border border-red-100 dark:border-red-500/30 text-red-400 hover:bg-red-50 dark:hover:bg-red-500/10 hover:text-red-500 transition-colors shadow-sm"
                            title="Remove file"
                        >
                            <HugeiconsIcon icon={Cancel01Icon} size={11} />
                        </button>
                    </>
                ) : (
                    <>
                        <HugeiconsIcon icon={FileAddIcon} size={22} className="text-gray-300 mb-2" />
                        <p className="text-xs font-semibold text-[#1e3a6e] dark:text-blue-400">Choose file</p>
                        <p className="text-[10px] text-gray-400 mt-0.5">PNG, JPG, PDF, DOC, XLS up to 10MB</p>
                    </>
                )}
            </label>
        </div>
    );
}

export default FormUpload;
